import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../components/CustomText";
import CustomBoard from "../../components/CustomBoard";
import Color from "../../../utils/Color";
import "fontsource-muli";
import CustomTextInput from "../../components/CustomTextInput";
import CustomButton from "../../components/CustomButton";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as selector from "../../../common/selectors";
import * as authSelector from "../../../common/selectors/auth";
import * as authAction from "../../../common/actions/auth";
import Image from "../../../assets";
import Grid from "@material-ui/core/Grid";
import LoadingOverlay from "../../components/LoadingOverlay";
import AuthorizationMaybankRedirect from "../AuthorizationRedirectMaybank";

class AuthorizationMaybank extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authState: "Maybank",
      redirectUrl: "www.google.com",
      localAuthClientID: "",
      localAuthRedirectURL: "",
      localAuthState: "",
      isVisibleConsentPrompt: false,
      consentPromptFailed: false,
      onClickOkAction: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    var authClientID = this.getUrlVars()["AuthClientId"];
    var authRedirectUrl = this.getUrlVars()["AuthRedirectUrl"];
    var authState = this.getUrlVars()["AuthState"];
    this.setState({
      localAuthClientID: authClientID,
      localAuthRedirectURL: authRedirectUrl,
      localAuthState: authState,
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }


  componentDidUpdate() {
    const {
      getAuthorizationAuthStatus,
      getAuthorizationAuthLoading,
      getAuthorizationAuthData,
    } = this.props;

    if (
      getAuthorizationAuthStatus === true &&
      getAuthorizationAuthLoading === false &&
      this.state.onClickOkAction === true
    ) {
      const { history } = this.props;
      const authoDataMsg = authSelector.getAuthorizationAuthDataMsg(
        getAuthorizationAuthData
      );
      if (
        authoDataMsg ===
        "Authorization failed. Please try again later or contact Customer Service"
      ) {
        this.setState({
          isVisibleConsentPrompt: true,
          consentPromptFailed: true,
        });
      } else {
        this.setState({
          isVisibleConsentPrompt: true,
          consentPromptFailed: false,
        });
      }
     
      this.setState({ onClickOkAction: false });
    }
  }

  getUrlVars = () => {
    var vars = {};
    var parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        vars[key] = value;
      }
    );
    return vars;
  };

  handleCloseAuthorizationMaybank = () => {
    this.setState({ isVisibleConsentPrompt: false });
  };

  updateWindowDimensions() {
    this.setState({ height: window.innerHeight });
  }

  onClickSubmit = () => {
    const { getAuthorizationAuth } = this.props;
    getAuthorizationAuth(
      this.state.localAuthState,
      this.state.localAuthRedirectURL
    );
    this.setState({ onClickOkAction: true });
  };


  renderChildren = () => {
    const { classes } = this.props;

    return (
      <div style={{height:"100vh"}}>
        <Grid className={classes.etiqaLogo} style={{marginTop: window.innerWidth < 650 ? 65 : false }}>
          <img src={Image.etiqaLogo} />
        </Grid>

        <CustomText design={classes.headerTextStyle}>
          Authorization Page
        </CustomText>
        <CustomText design={classes.contentTextStyle}>
          Maybank is requesting access to your Etiqa Life Policies
        </CustomText>
        <CustomText design={classes.contentTextStyle}>
          Please select OK to provide consent.
        </CustomText>
        <Grid container style={{ alignItems: "center" }}>
          <Grid item xs={2}></Grid>
          <Grid item xs={8}>
            <CustomButton
              title={"OK"}
              design={classes.buttonStyle1}
              onClick={this.onClickSubmit}
            />
          </Grid>
          <Grid item xs={2}></Grid>
        </Grid>
      </div>
    );
  };

  render() {
    const {
      classes,
      getAuthorizationAuthLoading,
      getAuthorizationAuthData,
    } = this.props;
    const { height } = this.state;
    const redirectUrl = authSelector.getAuthorizationAuthDataRedirectUrl(
      getAuthorizationAuthData
    );
    const authoDataMsg = authSelector.getAuthorizationAuthDataMsg(
      getAuthorizationAuthData
    );
    return (
      <div className={classes.root}>
        {/* <CustomBoard children={this.renderChildren()} height={height} /> */}
        {this.renderChildren()}
        <AuthorizationMaybankRedirect
          isVisible={this.state.isVisibleConsentPrompt}
          redirectUrl={redirectUrl}
          consentPromptFailed={this.state.consentPromptFailed}
          authoDataMsg={authoDataMsg}
          handleClose={this.handleCloseAuthorizationMaybank}
        />
        {getAuthorizationAuthLoading ? (
          <LoadingOverlay loading={true} />
        ) : (
          false
        )}
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
  headerTextStyle: {
    ...getFontWeight("800"),
    fontSize: 23,
    textAlign: "center",
    color: "#2c3034",
    marginBottom: "1em",
  },
  contentTextStyle: {
    ...getFontWeight("500"),
    fontSize: 17,
    textAlign: "center",
    color: "#2c3034",
    marginBottom: "1em",
  },
  labelTextInputTextStyle: {
    ...getFontWeight("600"),
    ...getFontSize("medium"),
    color: Color.primaryTextColor,
  },
  textInputContainer: {
    height: 40,
    marginTop: 5,
  },
  inputContainer: {
    marginTop: 40,
  },
  buttonStyle1: {
    ...getFontWeight("800"),
    fontSize: 28,
    textAlign: "center",
    marginTop: "0.5em",
    alignSelf: "center",
  },
  etiqaLogo: {
    textAlign: "center",
    alignSelf: "center",
    marginTop: "-1em",
  },
});

function mapStateToProps(state) {
  return {
    getAuthorizationAuthData: selector.getAuthorizationAuthData(state),
    getAuthorizationAuthLoading: selector.getAuthorizationAuthLoading(state),
    getAuthorizationAuthStatus: selector.getAuthorizationAuthStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAuthorizationAuth: (authState, authRedirectUrl) =>
      dispatch(authAction.getAuthorizationAuth(authState, authRedirectUrl)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(AuthorizationMaybank)));
